import Config from "~/config";

export interface PasswordResetRequest {
	body: string;
	url: string;
}

export const buildPasswordResetRequest = (email: string): PasswordResetRequest => ({
	body: JSON.stringify({ applicationId: Config.clientId, loginId: email.trim() }),
	url: `${Config.authUrl}/api/user/forgot-password`
});

const requestPasswordReset = async (email: string): Promise<void> => {
	const { body, url } = buildPasswordResetRequest(email);
	const response = await fetch(url, {
		method: "POST",
		headers: { "Content-Type": "application/json" },
		body
	});

	if (!response.ok) {
		throw new Error("We couldn't send a reset link. Please try again.");
	}
};

export default requestPasswordReset;
